<template>
    <template v-if="!loading && !error && audiences.length > 0">
        <div class="container-fluid item-lists-type-8">
            <div class="container">
                <AudiencesListItem
                    v-for="(audience, index) in audiences"
                    :key="index"
                    :audience="audience"
                />
            </div>
        </div>
    </template>

    <div v-else-if="!loading && !error" class="container-fluid content-type-38">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-3">
                    <div class="content">
                        <h2 class="h4">{{$t('views.audiences.no_results_title')}}</h2>
                        <p class="p">{{$t('views.audiences.no_results')}}</p>
                        <router-link class="btn-1 btn-s-icon" :to="{ name: 'companies' }">
                            <div class="icon-company-pos"></div>
                            <span class="text">{{$t('links.companies')}}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ErrorSection v-else-if="error" :error="error" />
    <LoadingSection v-else />
</template>

<script>
    import { mapActions, mapState } from 'pinia';
    import { useAudiencesStore } from '@/stores/audiences';
    import AudiencesListItem from '@/components/audiences/AudiencesListItem';
    import ErrorSection from '@/components/sections/ErrorSection';
    import LoadingSection from '@/components/sections/LoadingSection';

    export default {
        name: 'AudiencesList',
        components: {
            AudiencesListItem,
            ErrorSection,
            LoadingSection
        },
        computed: {
            ...mapState(useAudiencesStore, ['audiences', 'loading', 'error', 'found']),
        },
        methods: {
            ...mapActions(useAudiencesStore, ['fetchAudiences', 'resetAudiences'])
        },
        mounted() {
            this.resetAudiences();
            this.fetchAudiences();
        }
    }
</script>